import { FC, useState } from 'react'
import { useAuth } from '../../auth'
import { useNavigate } from 'react-router-dom'

import { Button, NavLink } from 'react-bootstrap'
import { Dialog } from 'primereact/dialog'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleNotch, faSignOutAlt } from '@fortawesome/free-solid-svg-icons'

const Logout: FC = () => {
    const [show, setShow] = useState(false)

    const handleClose = () => setShow(false)
    const handleShow = () => setShow(true)

    const { logout } = useAuth()
    const navigate = useNavigate()
    const [isLoggingOut, setIsLoggingOut] = useState(false)

    const handleLogout = async (e: React.MouseEvent) => {
        e.preventDefault()

        setIsLoggingOut(true)

        try {
            await logout()
            navigate('/login')
        } catch (err) {
            console.error(err)
        } finally {
            setIsLoggingOut(false)
        }
    }

    const headerElement = (
        <div className="inline-flex align-items-center justify-content-center gap-2">
            <FontAwesomeIcon icon={faSignOutAlt} className="me-1" /> Logout?
        </div>
    )

    const footerContent = (
        <div className="border-top pt-3">
            <Button
                variant="outline-danger"
                disabled={isLoggingOut}
                onClick={handleClose}
            >
                No, stay in!
            </Button>
            <Button
                variant="outline-primary"
                disabled={isLoggingOut}
                onClick={handleLogout}
            >
                {isLoggingOut ? (
                    <>
                        <FontAwesomeIcon icon={faCircleNotch} spin={true} />{' '}
                        Logging out...
                    </>
                ) : (
                    <>Yes</>
                )}
            </Button>
        </div>
    )

    return (
        <>
            <NavLink
                className={'nav-link'}
                disabled={isLoggingOut}
                onClick={handleShow}
            >
                {isLoggingOut ? (
                    <>
                        <FontAwesomeIcon
                            icon={faCircleNotch}
                            spin={true}
                            className="text-danger"
                        />{' '}
                        <FontAwesomeIcon
                            icon={faSignOutAlt}
                            className="fa-fw text-danger"
                        />
                    </>
                ) : (
                    <FontAwesomeIcon
                        icon={faSignOutAlt}
                        className="fa-fw text-danger"
                    />
                )}
            </NavLink>

            <Dialog
                visible={show}
                modal
                header={headerElement}
                footer={footerContent}
                style={{ width: '30rem' }}
                position="top"
                draggable={false}
                onHide={() => {
                    if (!show) return
                    setShow(false)
                }}
            >
                <h5 className="m-0 pt-5">Are you sure?</h5>
            </Dialog>
        </>
    )
}

export default Logout
